import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LocalStorageService } from '../services/localStorage/localStorage.service';
import { urlRoutes } from '../constants/url-route.constant';
import { NavigationService } from '../services/navigation/navigation.service';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard implements CanActivate {
    constructor(
        private localStorageService: LocalStorageService,
        private navigationService: NavigationService
    ) {}

    canActivate(): boolean {
        if (this.localStorageService.isAuthenticated() && this.localStorageService.hasPermission()) {
            console.log('2')
            return true;
        } else {
            this.localStorageService.clearAll(); // Clear all local storage if not authenticated
            // Redirect to the login page if not authenticated
            console.log('1')
            this.navigationService.routeToPath(`/${urlRoutes.authentication}/${urlRoutes.login}`);
            return false;
        }
    }
}
